var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.92374 11.9322C7.95203 11.8332 7.96617 11.7837 7.98737 11.7376C8.0062 11.6966 8.02914 11.6576 8.05583 11.6212C8.0859 11.5802 8.12231 11.5438 8.19512 11.471L12.4997 7.16647C12.9599 6.70623 13.7061 6.70623 14.1664 7.16646C14.6266 7.6267 14.6266 8.37292 14.1664 8.83317L9.86179 13.1377C9.78897 13.2105 9.75257 13.2469 9.71161 13.277C9.67525 13.3037 9.63626 13.3266 9.59526 13.3454C9.54909 13.3666 9.49959 13.3808 9.40058 13.4091L7.33301 13.9998L7.92374 11.9322Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99968 10.3333H4.99968C4.0693 10.3333 3.60411 10.3333 3.22558 10.4482C2.37331 10.7067 1.70637 11.3736 1.44783 12.2259C1.33301 12.6044 1.33301 13.0696 1.33301 14M9.66634 5C9.66634 6.65685 8.3232 8 6.66634 8C5.00949 8 3.66634 6.65685 3.66634 5C3.66634 3.34315 5.00949 2 6.66634 2C8.3232 2 9.66634 3.34315 9.66634 5Z",
    stroke: "#474747",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-edit.caa2d1c72def252126516c6713832f21.svg";